import React from "react";
import { Link } from "react-router-dom";
import { MaskedReveal, FadeUp } from "@/components/motion/Reveal";
import { Marquee } from "@/components/motion/Marquee";
import { BLOGS } from "@/data/site";
import { ArrowUpRight } from "lucide-react";

function formatDate(d) {
  return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export default function Blog() {
  const [featured, ...rest] = BLOGS;
  return (
    <div data-testid="blog-page">
      <section className="pt-40 pb-12">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <div className="mono text-xs uppercase tracking-[0.32em] text-gold mb-6">Chapter 00 · Journal</div>
          <MaskedReveal as="h1" className="serif text-6xl md:text-[9vw] leading-[0.92]" lines={["Notes on the", <em className="italic text-gold">law of the land.</em>]} />
          <FadeUp delay={0.3} className="mt-10 max-w-2xl text-[hsl(var(--muted-foreground))]">
            Case-law digests, procedural primers and firm commentary on developments across our practice areas.
          </FadeUp>
        </div>
      </section>

      {featured && (
        <section className="pb-16">
          <div className="mx-auto max-w-[1400px] px-6 md:px-10">
            <Link to={`/blog/${featured.slug}`} className="group grid grid-cols-12 gap-6 md:gap-10 items-end" data-testid={`blog-row-${featured.slug}`}>
              <div className="col-span-12 md:col-span-7 aspect-[16/10] overflow-hidden hairline border">
                <img src={featured.hero} alt={featured.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
              </div>
              <div className="col-span-12 md:col-span-5">
                <div className="mono text-xs uppercase tracking-[0.28em] text-gold mb-4">{featured.category} · {formatDate(featured.date)}</div>
                <h2 className="serif text-4xl md:text-5xl leading-tight group-hover:text-gold transition-colors">{featured.title}</h2>
                <p className="mt-6 text-[hsl(var(--muted-foreground))] leading-relaxed">{featured.excerpt}</p>
                <div className="mt-8 editorial-link text-sm uppercase tracking-[0.22em]">Read essay <ArrowUpRight className="h-4 w-4" /></div>
              </div>
            </Link>
          </div>
        </section>
      )}

      <section className="pb-24">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 divide-y hairline border-y hairline">
          {rest.map((b, i) => (
            <Link key={b.slug} to={`/blog/${b.slug}`} className="group grid grid-cols-12 gap-6 md:gap-10 py-10 items-start" data-testid={`blog-row-${b.slug}`}>
              <div className="col-span-2 mono text-[10px] uppercase tracking-[0.28em] text-[hsl(var(--muted-foreground))]">
                {formatDate(b.date)}<br />{b.reading}
              </div>
              <div className="col-span-10 md:col-span-6">
                <div className="mono text-xs uppercase tracking-[0.28em] text-gold mb-3">{b.category}</div>
                <h3 className="serif text-3xl md:text-4xl leading-snug group-hover:text-gold transition-colors">{b.title}</h3>
              </div>
              <div className="hidden md:block md:col-span-3 text-[hsl(var(--muted-foreground))] text-[15px] leading-relaxed">{b.excerpt}</div>
              <div className="hidden md:block md:col-span-1 justify-self-end">
                <ArrowUpRight className="h-6 w-6 group-hover:rotate-45 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </section>

      <Marquee items={["Case Law", "Precedent", "Procedure", "Commentary", "Judgments"]} />
    </div>
  );
}
